import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, GridLegacy as Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { AppBarWithButtons } from '../../../../components/designe/app-bars/app-bar-with-action-buttons/AppBarWithButtons';
import AppUserAvatar from '../../../../components/designe/app-entity-avatar/app-user-avatar/AppUserAvatar';
import AppUploadFileButton from '../../../../components/designe/buttons/app-upload-file-button/AppUploadFileButton';
import AppFormTextField from '../../../../components/designe/forms/app-form-text-field';
import { useNavigationStack } from '../../../../context/NavigationStackContext';
import { useUnsavedChangesGuard } from '../../../../hooks/useUnsavedChangesGuard';
import { AvatarSize, AvatarTypes } from '../../../../shared/constants';
import { Paths } from '../../../../shared/paths';
import { uploadFilesUtils } from '../../../../utils/files/upload-files-utils';
import { useStyles } from './UserInfoEdit.styles';
import { useUserInfoEditComponent } from './useUserInfoEditComponent';

export default function UserInfoEdit(props) {
  const { t } = useTranslation();
  const theme = useTheme();

  const { classes } = useStyles(theme);
  const { user, formik, avatar, setAvatar, isLoading } =
    useUserInfoEditComponent();
  const { replace } = useNavigationStack();
  const { allowAndLeave, dialog } = useUnsavedChangesGuard({
    isDirty: (formik.dirty || !!avatar) && !formik.isSubmitting,
    leaveAction: () => replace(Paths.settings.toInfoView),
  });

  return (
    <div className={classes.userInfoWrapper}>
      {dialog}
      <form onSubmit={formik.handleSubmit} className={classes.userInfoForm}>
        <Box className={classes.userInfoContent}>
          <Box className={classes.avatarWrapper}>
            <AppUserAvatar
              fileBlob={avatar?.fileBlob}
              entity={user}
              size={AvatarSize.l}
              type={AvatarTypes.square}
            />
          </Box>

          <AppUploadFileButton
            variant="outlined"
            label={t('settings.updateAvatar')}
            onFileInput={(e) => {
              uploadFilesUtils(e.target.files).then((uploadedFiles) => {
                setAvatar(uploadedFiles[0]);
              });
            }}
          />
        </Box>
        <Box marginTop={2}>
          <AppFormTextField
            label={t('common.firstname')}
            fullWidth
            name="firstname"
            formik={formik}
          />
        </Box>
        <Box marginTop={2}>
          <AppFormTextField
            label={t('common.lastname')}
            fullWidth
            name="lastname"
            formik={formik}
          />
        </Box>
        <Box marginTop={2}>
          <AppFormTextField
            label={t('common.description')}
            fullWidth
            multiline
            minRows={3}
            maxRows={6}
            name="description"
            formik={formik}
          />
        </Box>
        <Box>
          <Box className={classes.buttonWrapper}>
            <AppBarWithButtons
              loading={isLoading}
              disabled={!formik.dirty && !avatar}
              onCancelClick={allowAndLeave}
            />
          </Box>
        </Box>
      </form>
    </div>
  );
}
